import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';
import { EVENTS as PDPEvents, bus as EventBus } from '../../components/product/bootstrap';

const init = function() {
	const lightbox = new PhotoSwipeLightbox({
		// may select multiple "galleries"
		gallery: '#ProductDisplayPageMainGalleryCarouselList',
	  
		// Elements within gallery (slides)
		children: 'a',
	  
		// setup PhotoSwipe Core dynamic import
		pswpModule: PhotoSwipe
	  });
	  lightbox.init();
};


//DOM has been updated, let's rewire
EventBus.subscribe(PDPEvents.SECTION_UPDATED, init);

init();